module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.customer.orders.length > 0) ? _c('div', [_vm._l((_vm.customer.orders), function(order, index) {
    return [(_vm.customer.orders) ? _c('div', {
      key: index
    }, [_c('order-view', {
      on: {
        "click": function($event) {
          return _vm.toggleOrder(index)
        }
      },
      model: {
        value: (_vm.customer.orders[index]),
        callback: function($$v) {
          _vm.$set(_vm.customer.orders, index, $$v)
        },
        expression: "customer.orders[index]"
      }
    })], 1) : _vm._e()]
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38d35540","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/OrderTab.vue
// module id = 493
// module chunks = 1